<template>
  <div class="body-div">
    <div class="main-chart">
      <canvas id="live-stats-sub-chart-finance" width="1"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

const finChartData = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          // return value === 0 ? value : value;
          return value;
        }
      }
    },
    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 9
          }
        }
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      mode: "index",
      intersect: false
    }
  }
};

Chart.Tooltip.positioners.custom = function(elements, position) {
  if (!elements.length) {
    return false;
  }
  let offset = 0;
  //adjust the offset left or right depending on the event position
  if (elements[0]._chart.width / 2 > position.x) {
    offset = 20;
  } else {
    offset = -20;
  }
  return {
    x: position.x + offset,
    y: 0
  };
};
export default {
  name: "ChartFinance.component.component",
  props: {
    rangePaymentMethodData: {
      type: Array
    }
  },

  data() {
    return {
      finChartData: finChartData,
      reqMainChartData: false,
      loaderIcon: false,
      mainChartData: [],
      mainChartTabBuild: null,
      chartTimeOut: null,
      lastUpdate: null,
      statsDate: [moment().toDate(), moment().toDate()],
      usersList: [],
      selectedUser: null,
      avgOptions: [
        {
          id: 1,
          name: "AVG 7",
          alias: 7
        },
        {
          id: 2,
          name: "AVG 30",
          alias: 30
        },
        {
          id: 3,
          name: "AVG 90",
          alias: 90
        },
        {
          id: 4,
          name: "AVG 180",
          alias: 180
        }
      ],
      selectedAvgRange: 30,
      selectedAvg: "AVG 30",
      selectedTierOption: null,
      expendedChartData: {},
      selectedTier: "ALL TIERS",
      LeadFiltersOptions: [
        {
          id: 1,
          name: "ALL LEADS",
          alias: "ALL"
        },
        {
          id: 2,
          name: "DUP",
          alias: "DUP"
        },
        {
          id: 3,
          name: "REG",
          alias: "REG"
        }
      ],
      selectedLeadFilter: "ALL",
      selectedLeadOption: "ALL LEADS",
      allAvgStats: {},
      avgRawStats: [],
      chartKeys: [
        ["COST", [1, 2]],
        ["REG", [1, 2, 3, 4, 5, 12]],
        ["NEW", [1, 2, 3, 4, 5, 12]],
        ["NR", [1, 2, 3, 4, 5, 12]],
        ["NI", [1, 2, 3, 4, 5, 12]],
        ["BN", [1, 2, 3, 4, 5, 12]],
        ["NU", [1, 2, 3, 4, 5, 12]],
        ["MERGED", [1, 2, 3, 4, 5, 12]],
        ["ENDED", [1, 2, 3, 4, 5, 12]],
        ["TR-LV", [1, 2, 3, 4, 5, 12]],
        ["TR-ON", [1, 2, 3, 4, 5, 12]],
        ["C2C", [1, 2, 3, 4, 5, 12]],
        ["SMS", [1, 2, 3, 4, 5, 12]],
        ["CA", [1, 2, 3, 4, 5, 12]],
        ["NA", [1, 2, 3, 4, 5, 12]],
        ["RF", [1, 2, 3, 4, 5, 12]],
        ["LD", [1, 2, 3, 4, 5, 12]],
        ["DEP", [1, 2, 3, 4, 5, 12]],
        ["CC-DEC", [1, 2, 3, 4, 5, 12]]
      ]
    };
  },
  beforeDestroy() {
    this.$root.$off("updateLiveStats");
  },
  mounted() {
    this.buildChartData();
  },
  watch: {
    updateLiveChart: function() {
      if (this.updateLiveChart) {
        if (this.updateLiveChart.dates) {
          if (!this.updateLiveChart.dates.start) {
            this.updateLiveChart.dates.start = undefined;
          }
          if (!this.updateLiveChart.dates.end) {
            this.updateLiveChart.dates.end = undefined;
          }
          this.statsDate = [
            moment(this.updateLiveChart.dates.start).toDate(),
            moment(this.updateLiveChart.dates.end).toDate()
          ];
        } else {
          this.statsDate = [moment().toDate(), moment().toDate()];
        }
        if (this.updateLiveChart.lead_filter) {
          this.selectedLeadFilter = this.updateLiveChart.lead_filter;
          this.$store.commit(
            "clients/setLiveDataFilter",
            this.selectedLeadFilter
          );
        }
        this.$store.commit("clients/setUpdateLiveChart", false);
      }
    }
  },
  methods: {
    buildChartData() {
      let labels = [];
      let Count = [];
      this.rangePaymentMethodData.forEach(r => {
        if (
          r.method == "T.Expenses" ||
          r.method == "T.Income" ||
          r.method == "T.Sum"
        ) {
          labels.push(r.method);
          Count.push(r.count);
        }
      });

      let canvas = "live-stats-sub-chart-finance";
      this.createMainSubChart(Count, labels, canvas, this.finChartData);
    },
    chunksArray(tempArr, perChunk) {
      let arr = tempArr.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
      return arr;
    },
    createMainChart(statsAll, canvasId, chartOpt, AvgStats) {
      let opt = chartOpt.options;
      let labels = this.rangePaymentMethodData[0];
      let allStats = this.dataFromGraphChart[1];

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Count",
            data: allStats, //onlineTrans,
            fill: true,
            borderColor: "rgb(255,0,0,0.7)",
            backgroundColor: "rgb(255,0,0,0.7)",
            borderWidth: 0.5,
            maxBarThickness: 30,
            categoryPercentage: 1.0,
            barPercentage: 0.5
          }
        ]
      };

      if (this.mainChartTabBuild) {
        this.mainChartTabBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.mainChartTabBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    },
    createMainSubChart(counts, labels, canvasId, chartOpt) {
      let opt = chartOpt.options;

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Count",
            data: counts, //onlineTrans,
            fill: true,
            borderColor: "rgb(255,0,0,0.7)",
            backgroundColor: "rgb(255,0,0,0.7)",
            borderWidth: 0.5,
            maxBarThickness: 30,
            categoryPercentage: 1.0,
            barPercentage: 0.5
          }
        ]
      };

      if (this.mainChartTabBuild) {
        this.mainChartTabBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      data.datasets[0].data.map((num, idx) => {
        if(parseInt(num) > 0){
          num = '+' + num;
          data.datasets[0].data[idx] = num;
        }
      })

      this.mainChartTabBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    }
  }
};
</script>

<style scoped>
/*@import "../../../../../../public/css/datePicker.css"; // TODO: Moved to CDN*/
html * {
  text-transform: capitalize;
}
.body-div {
  /*padding: 5px 5px 1px 5px;*/
  padding-top: 5px;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.main-chart {
  min-width: 100%;
  height: 100%;
  margin: auto;
  background: white;
  border-radius: 3px;
  /*padding: 5px;*/
  position: relative;
}
.last-update-date {
  position: absolute;
  font-size: 12px;
  z-index: 1;
  right: 1px;
  top: -5px;
}
.refresh-button {
  position: absolute;
  font-size: 10px;
  z-index: 1;
  right: 100px;
  top: -5px;
  height: 18px;
}
.report-calendar {
  /*margin-top: 13px;*/
}
.selection-user-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /*height: 30px;*/
  border-radius: 0px;
}
.dropdown-menu.ul-users {
  font-size: 14px;
  overflow-y: scroll;
  max-height: 167px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 200px;
}
.dropdown-menu.ul-tiers {
  font-size: 11px;
  max-height: 225px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 73px;
}
.dropdown-menu.ul-tiers > li > a {
  padding: 3px 12px;
}
.dropdown-menu {
  border-radius: 0;
}
.activedrop {
  background-color: #efefef;
}
/*.tiers-btns{*/
/*  flex: 1;*/
/*}*/
.tiers-btn {
  border: 0px;
  border-radius: 0px;
  width: 100%;
  font-size: 10px;
  height: 15px;
}
.tiers-btn p {
  margin-bottom: 0px;
}
.tiers-btn:focus {
  outline: none;
}
.tiers-btn.active {
  background-color: #44a2d2;
  color: #fff;
}
.selecting-options {
  display: flex;
}
.loader-icon {
  display: flex;
  justify-content: center;
}
.loader-icon > span > img {
  width: 15px;
}
</style>
